import { useAuth } from "@clerk/clerk-react";
import type { ReactNode } from "react";

import { api } from "@/services/api";

/**
 * Installs the Clerk JWT getter on the API client.
 *
 * The getter is set **synchronously during render**, not in an effect: React
 * Query starts queries from the mount effects of descendant components, and
 * descendant effects run *before* an ancestor's effect would. Wiring the token
 * getter in an effect here could therefore leave the very first admin request
 * unauthenticated. Assigning during render is idempotent (it only stores a
 * closure) and guarantees the getter is in place before any descendant query
 * fires — this component must sit above the QueryClientProvider.
 */
export function ApiAuthBridge({ children }: { children: ReactNode }) {
  const { getToken } = useAuth();

  api.setTokenGetter(async () => {
    try {
      return await getToken();
    } catch {
      return null;
    }
  });

  return <>{children}</>;
}
